import lightbox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';

$(document).ready(() => {
  $('.image-set').trigger('click');
});

lightbox.option({ 
  resizeDuration: 300, 
  wrapAround: true,
  imageFadeDuration: 300
});
